module.exports = __webpack_public_path__ + "img/6.e9868662.jpg";